import React from "react";
import CustomInput from "../../../components/CustomInput";
import CustomSelect from "../../../components/CustomSelect";

const TabAccountInfo = ({ formData, onInputChange, errors, isEdit }) => {
  return (
    <form className="">
      <h2 className="text-md font-sf-medium text-gray-900 mb-2">
        Thông tin tài khoản
      </h2>
      <div className={`grid gap-4 ${isEdit ? "grid-cols-3" : "grid-cols-2"}`}
      >
        {isEdit &&
          <CustomInput
            placeholder="Mã số khách hàng"
            value={formData.staffCode || ""}
            error={errors?.staffCode}
            onChange={() => { }}
            disabled={true}
          />
        }
        <CustomInput
          placeholder="Tên đăng nhập"
          value={formData.username || ""}
          error={errors?.username}
          onChange={(value) => onInputChange("username", value)}
        />
        <CustomInput
          placeholder="Mật khẩu"
          type="password"
          value={formData.password || ""}
          error={errors?.password}
          onChange={(value) => onInputChange("password", value)}
        />
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">
        <CustomSelect
          options={[{ value: "Manager", label: "Quản lý" }]}
          placeholder="Phân quyền"
          value={formData.role || ""}
          error={errors?.role}
          onChange={(value) => onInputChange("role", value)}
        />
        <CustomSelect
          options={[
            { value: "Đang hoạt động", label: "Đang hoạt động" },
            { value: "Không hoạt động", label: "Không hoạt động" },
          ]}
          placeholder="Trạng thái"
          value={formData.status || ""}
          error={errors?.status}
          onChange={(value) => onInputChange("status", value)}
        />
      </div>
    </form>
  );
};

export default TabAccountInfo;
